export default {
  searchresults: "Search Results",
  boxtitle: "You searched for",
  fuzzy: 'Inexact match for entities', 
  fuzzy_desc: 'This feature returns search results that contains approximate matches or misspelled words.',
  fuzzy_on: 'Enabled',
  fuzzy_off: 'Disabled',
  classification: 'DEBUG: {0} search',
  suggestion: 'Popular Keywords',
  suggestion_desc: 'Keywords that are frequently searched together. Click to add keywords to your search phrase.',
  changefilter: 'Refine Scope',
  legis_rec: 'Are you looking for ',
  status: "Status",
  toadv: "Use Advanced Search for more specific results",
  max_reached: 'Only the most {0} relevant results are provided',
  doc: 'Document Type',
  advs: {
    advanced: 'Advanced Search',
    advancedshort: 'Advanced',
    citation: 'Citation',
    neutral: 'Neutral Citation',
    legisname: "Legislation name",
    parties: "Parties of judgment",
    coram: "Coram of judgment",
    representation: "Parties representation",
    charge: "Charge",
    allwords: "All of these words",
    anywords: "Any of these words",
    phrase: "Exact phrase",
    help: "Search Help",
    specfield: "Search in specific fields",
    allfield: "Search in all fields",
    date: "Filter by Date",
    dbs: "Select Scope of Search",
    selecteddbs: "Select Specific Databases",
    selected: "selected",
  },
}